// REACT
import React, { Component } from "react";
import "./RemoteSensing.scss";
import NDVIpanel from "./NDVIpanel";
import NDMIpanel from "./NDMIpanel";

//OpenLayers
import GeoTIFF from "ol/source/GeoTIFF.js";
import WebGLTileLayer from "ol/layer/WebGLTile.js";
import GeoJSON from "ol/format/GeoJSON";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Fill, Stroke, Style } from "ol/style";
import { unByKey } from "ol/Observable.js";

import "semantic-ui-css/semantic.min.css";
import { Accordion, Icon, Dropdown } from "semantic-ui-react";
// import colormap from 'colormap';


// CONSTS
const indexList = [
  // { text: "True color_", value: 0 },
  { text: "True color", value: 0 },
  { text: "False color", value: 1 },
  { text: "NDVI", value: 2 },
  { text: "NDMI", value: 3 },
];

// const footprints_style = new Style({
//   fill: new Fill({
//     color: "rgba(255, 255, 255, 0.2)",
//   }),
//   stroke: new Stroke({
//     color: "#00aca6",
//     width: 3,
//   }),
// });
const footprints_style = new Style({
  fill: new Fill({
    color: "rgba(0, 0, 0, 0)",
  }),
  stroke: new Stroke({
    color: "rgba(0, 0, 0, 0)",
    width: 0,
  }),
});

class RSLayerControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      indexValue: "",
      mosaicVisible: true,
      mosaicsUrl: window.config.mosaicsUrl,
      opacity: 1,
      maxValue: 5500,
      mosaicCode: "",
      dateFrom: "",
      dateTo: "",
      mosaicFolder: "",
      url_RGB: "",
      toggleActiveIndex: 1,
      activeImage: "rgb",
      imgIndex: 0,
      rgb_variables: {
        exposure: 0,
        contrast: 0,
        saturation: 0,
        brightness: 0,
        gamma: 1,
      },
    };
    this.highlight = "";
    this.visualizations = [
      // {
      //   name: "True Color",
      //   sources: ["rgb"],
      //   style: {
      //     exposure: ["var", "exposure"],
      //     contrast: ["var", "contrast"],
      //     saturation: ["var", "saturation"],
      //     brightness: ["var", "brightness"],
      //     gamma: ["var", "gamma"],
      //     variables: this.state.rgb_variables,
      //   },
      //   // normalize: true,
      //   max: this.state.maxValue,
      // },
      {
        name: "True Color",
        normalize: true,
        sources: ["B04", "B03", "B02"],
        style: {
          exposure: ["var", "exposure"],
          contrast: ["var", "contrast"],
          saturation: ["var", "saturation"],
          brightness: ["var", "brightness"],
          gamma: ["var", "gamma"],
          variables: this.state.rgb_variables,
        },
        max: 5500,
      },
      {
        name: "falsecolor",
        sources: ["B08", "B04", "B03"],
        max: 6000,
      },
      {
        name: "ndvi",
        sources: ["B04", "B08"],
        style: {
          color: [
            "interpolate",
            ["linear"],
            [
              "/",
              ["-", ["band", 2], ["band", 1]],
              ["+", ["band", 2], ["band", 1]],
            ],
            // ['/', ['-',  this.normalize(['band', 2]),  this.normalize(['band', 1])], ['+',  this.normalize(['band', 2]),  this.normalize(['band', 1])]],
            // ...this.getColorStops('rainbow', -0.2, 1, 10, true),
            -1.1,
            [238, 238, 238],
            -0.2,
            [191, 33, 47],
            0,
            [215, 48, 39],
            0.025,
            [230, 79, 53],
            0.05,
            [244, 109, 67],
            0.075,
            [249, 142, 82],
            0.1,
            [253, 174, 97],
            0.125,
            [254, 199, 118],
            0.15,
            [254, 224, 139],
            0.175,
            [255, 255, 191],
            0.2,
            [236, 247, 168],
            0.25,
            [217, 239, 139],
            0.3,
            [166, 217, 106],
            0.35,
            [134, 203, 103],
            0.4,
            [102, 189, 99],
            0.45,
            [64, 171, 90],
            0.5,
            [26, 152, 80],
            0.55,
            [21, 140, 74],
            0.6,
            [15, 127, 67],
            0.65,
            [10, 115, 60],
            0.7,
            [4, 102, 53],
            1,
            [3, 83, 43],
          ],
        },
      },
      {
        // Sentinel-2 NDMI = (B08 - B11) / (B08 + B11)
        name: "ndmi",
        sources: ["B08", "B11"],
        max: 5000,
        style: {
          color: [
            "interpolate",
            ["linear"],
            [
              "/",
              ["-", ["band", 1], ["band", 2]],
              ["+", ["band", 1], ["band", 2]],
            ],
            -1.1,
            [238, 238, 238],
            -0.8,
            [151, 0, 0],
            -0.5,
            [184, 0, 0],
            -0.37,
            [223, 0, 0],
            -0.24,
            [252, 11, 5],
            -0.18,
            [255, 68, 0],
            -0.13,
            [255, 141, 0],
            -0.08,
            [255, 201, 0],
            -0.032,
            [253, 255, 1],
            -0.024,
            [218, 255, 37],
            -0.016,
            [186, 255, 69],
            -0.008,
            [153, 255, 101],
            0,
            [119, 255, 135],
            0.008,
            [93, 255, 161],
            0.016,
            [62, 255, 192],
            0.024,
            [26, 255, 227],
            0.03,
            [0, 239, 255],
            0.07,
            [0, 197, 255],
            0.13,
            [0, 133, 255],
            0.18,
            [0, 59, 255],
            0.24,
            [0, 0, 233],
            1,
            [0, 0, 136],
            // https://www.agricolus.com/en/vegetation-indices-ndvi-ndmi/
          ],
        },
      }
    ];
  }

  componentDidMount() {
    this.initializeNewImage();
    this.setIndexValue_event = window.map.on(["click"], this.setIndexValue);
    this.acquisitionDate_event = window.map.on(
      "pointermove",
      this.displayAcquisitionDate
    );
    window.dpz = {
      layer: indexList[0]["text"],
      opacity: 1,
    };
  }

  componentWillUnmount() {
    unByKey(this.acquisitionDate_event);
    unByKey(this.setIndexValue_event);
  }

  initializeNewImage = () => {
    this.removeMosaicLayer();
    this.props.onMosaicSelected(true);

    const mosaicFolder = `${this.state.mosaicsUrl}/${this.props.mosaicCode}`;
    const url_RGB = `${mosaicFolder}/rgb.tif`;

    this.setState(
      {
        mosaicCode: this.props.mosaicCode,
        dateFrom: this.props.dateFrom,
        dateTo: this.props.dateTo,
        mosaicFolder: mosaicFolder,
        url_RGB: url_RGB,
        opacity: 1,
      },
      () => {
        // pri vybere indexu sa prida aj podkladovka rgb
        if (
          (this.state.imgIndex === 1) |
          (this.state.imgIndex === 2) |
          (this.state.imgIndex === 3)
        ) {
          this.mosaicLayer_base = this.createLayer(
            this.state.mosaicFolder,
            this.visualizations[0]
          );
          this.mosaicLayer_base.set("name", "base_rgb");
          window.map.addLayer(this.mosaicLayer_base);
        }

        // add selected layer
        this.mosaicLayer = this.createLayer(
          this.state.mosaicFolder,
          this.visualizations[this.state.imgIndex]
        );

        // add footprint
        const footprints_URL = this.state.mosaicFolder + "/footprints.json";

        this.footprints_source = new VectorSource({
          url: footprints_URL,
          format: new GeoJSON(),
        });
        this.footprintsLayer = new VectorLayer({
          source: this.footprints_source,
          style: footprints_style,
        });

        this.footprintsLayer.set("name", "footprintsLayer");
        this.mosaicLayer.set("name", "mosaicLayer");

        window.map.addLayer(this.mosaicLayer);
        window.map.addLayer(this.footprintsLayer);

        const mosaicFolder = [
          this.state.mosaicsUrl,
          this.state.mosaicCode,
        ].join("/");
        window.dpz["mosaicFolder"] = mosaicFolder;
      }
    );
  };

  // getColorStops = (name, min, max, steps, reverse) => {
  //   const delta = (max - min) / (steps - 1);
  //   const stops = new Array(steps * 2);
  //   const colors = colormap({colormap: name, nshades: steps, format: 'rgba' });
  //   console.log("colors", colors)

  //   if (reverse) {
  //     colors.reverse();
  //   }
  //   for (let i = 0; i < steps; i++) {
  //     stops[i * 2] = min + i * delta;
  //     stops[i * 2 + 1] = colors[i];
  //   }
  //   // stops[1] = [238, 238, 238]
  //   console.log("test", stops[1])
  //   return stops;
  // }

  // const max = 3000;
  // normalize = (value) => {
  //   return ["/", value, 3000];
  // };

  createLayer = (base, visualization) => {
    const source = new GeoTIFF({
      sources: visualization.sources.map((id) => ({
        url: `${base}/${id}.tif`,
        max: visualization.max,
      })),
    });
    return new WebGLTileLayer({
      source: source,
      style: visualization.style,
    });
  };

  displayAcquisitionDate = (event) => {
    const pixel = window.map.getEventPixel(event.originalEvent);
    const feature = window.map.forEachFeatureAtPixel(pixel, function (feature) {
      return feature;
    });
    const dateDiv = document.getElementById("date-of-acquisition");

    if (feature) {
      const dateFromAttrTable = `${feature.get("date")}`;
      if (dateFromAttrTable !== "undefined") {
        const acquisitionDateStr = dateFromAttrTable.substring(0, 10);
        let year = acquisitionDateStr.substring(0, 4);
        let month = acquisitionDateStr.substring(5, 7);
        let day = acquisitionDateStr.substring(8, 10);
        let formattedDate = `${day}.${month}.${year}`;

        dateDiv.innerHTML = formattedDate;
      } else {
        dateDiv.innerHTML = "";
      }
    } else {
      dateDiv.innerHTML = "";
    }
  };

  setIndexValue = (event) => {
    const data = this.mosaicLayer.getData(event.pixel);
    if (!data) {
      return;
    }
    let indexValue = "";
    // NDVI
    if (this.state.imgIndex === 2) {
      const red = data[0];
      const nir = data[1];
      const ndvi = (nir - red) / (nir + red);
      indexValue = ndvi.toFixed(2);
      this.setState({ indexValue });
      // NDMI
    } else if (this.state.imgIndex === 3) {
      const B08 = data[0];
      const B11 = data[1];
      const ndmi = (B08 - B11) / (B08 + B11);
      indexValue = ndmi.toFixed(2);
      this.setState({ indexValue });
    }
  };

  removeMosaicLayer = () => {
    this.props.onMosaicSelected(false);

    window.map.getLayers().forEach(function (layer) {
      if (layer !== undefined) {
        if (layer.get("name") === "footprintsLayer") {
          window.map.removeLayer(layer);
        }
      }
    });

    window.map.getLayers().forEach(function (layer) {
      if (layer !== undefined) {
        if (layer.get("name") === "mosaicLayer") {
          window.map.removeLayer(layer);
        }
      }
    });

    window.map.getLayers().forEach(function (layer) {
      if (layer !== undefined) {
        if (layer.get("name") === "base_rgb") {
          window.map.removeLayer(layer);
        }
      }
    });
  };

  toggleVisibleMosaicLayer = () => {
    this.setState({ mosaicVisible: !this.state.mosaicVisible }, () => {
      this.mosaicLayer.setVisible(this.state.mosaicVisible);
      try {
        this.mosaicLayer_base.setVisible(this.state.mosaicVisible);
      } catch (error) {
        // console.log("error?");
      }
    });
    //change icon
    const icon = document.getElementById("icon-eye");
    icon.classList.toggle("slash");
  };

  // opacity
  handleOpacityChange = (e) => {
    let opacity = parseFloat(e.target.value);

    this.setState({ opacity: e.target.value }, () => {
      window.dpz["opacity"] = this.state.opacity;
    });
    document.getElementById("opacityValue").innerHTML = e.target.value;
    this.mosaicLayer.setOpacity(opacity);
  };

  handleMaxValue = (e, step) => {
    const maxValue =
      this.state.maxValue === undefined ? 100 : this.state.maxValue;
    const val = parseInt(maxValue) + step;
    this.setState({ maxValue: val }, () => {
      window.dpz["max_value"] = this.state.maxValue;
      this.visualizations[this.state.imgIndex]["max"] = this.state.maxValue;
      this.initializeNewImage();
    });
  };

  handleStyleVariables = (e, property, step) => {
    let val = parseFloat(this.state.rgb_variables[property]) + step;

    this.setState({ [property]: val }, () => {
      this.mosaicLayer.updateStyleVariables({
        [property]: val,
      });
    });
    window.dpz["rgb_variables"] = this.state.rgb_variables;
  };

  resetRGB = () => {
    this.setState(
      {
        exposure: 0,
        contrast: 0,
        brightness: 0,
        saturation: 0,
        gamma: 1,
      },
      () => {
        this.mosaicLayer.updateStyleVariables({
          exposure: 0,
          contrast: 0,
          brightness: 0,
          saturation: 0,
          gamma: 1,
        });
      }
    );
    // delete this.visualizations[0].max;
    this.setState({ maxValue: "100" });
    // this.initializeNewImage();
    window.dpz = {
      layer: indexList[0]["text"],
      max_value: 5500,
      // "opacity": undefined,
      rgb_variables: {
        exposure: 0,
        contrast: 0,
        saturation: 0,
        brightness: 0,
        gamma: 1,
      },
    };
  };

  onToggleFilter = () => {
    const newIndex = this.state.toggleActiveIndex === 1 ? 0 : 1;
    this.setState({ toggleActiveIndex: newIndex });
  };

  handleImageChange = (e, props) => {
    this.setState({
      activeImage: props.value,
      imgIndex: props.value,
      opacity: 1,
    });
    this.initializeNewImage();
    window.dpz["layer"] = indexList[props.value]["text"];
    // window.dpz["layer"] = props.value;
  };

  render() {
    return (
      <>
        <div id="layer-control">
          <div id="header">
            <h5 className="title-h2">Pridaná vrstva</h5>
            <div className="container" id="layer-control-header">
              <div className="item" id="period">
                <strong>
                  {this.state.dateFrom} - {this.state.dateTo}
                </strong>
              </div>
              <div className="item" id="buttons">
                <button
                  className="ui button btnInLayerHeader container"
                  onClick={() => this.toggleVisibleMosaicLayer()}
                  title="Skryť/zobraziť mozaiku"
                >
                  <i className="eye slash icon" id="icon-eye"></i>
                </button>
                <button
                  className="ui button btnInLayerHeader container"
                  onClick={() => {
                    this.removeMosaicLayer();
                    window.dpz = {
                      layer: undefined,
                      max_value: undefined,
                      opacity: undefined,
                      rgb_variables: undefined,
                      mosaicFolder: undefined,
                    };
                  }}
                  title="Odstrániť mozaiku"
                >
                  <i className="trash alternate icon"></i>
                </button>
              </div>
            </div>
          </div>
          <br />
          <div id="layer-control-body">
            <strong className="title-h2">Výber indexu</strong>
            <Dropdown
              placeholder="True color"
              selection
              fluid
              compact
              noResultsMessage="Obsah sa nenašiel"
              options={indexList}
              onChange={(e, props) => this.handleImageChange(e, props)}
              value={this.state.activeImage}
              spellCheck="false"
            />
            <br />
            <div className="layerOpacity">
              <div className="text-h1">Viditeľnosť:</div>
              <div id="opacityControl">
                <input
                  className="ui slider"
                  type="range"
                  id="opacitySlider"
                  name="opacity"
                  step="0.01"
                  min="0"
                  max="1"
                  value={this.state.opacity}
                  onChange={this.handleOpacityChange}
                />
              </div>
              <output id="opacityValue">{this.state.opacity}</output>
            </div>
            {this.state.imgIndex === 2 && (
              <NDVIpanel indexValue={this.state.indexValue} />
            )}
            {this.state.imgIndex === 3 && (
              <NDMIpanel indexValue={this.state.indexValue} />
            )}
            <div className="acquisitionDate">
              <p>
                <span className="text-h1">Dátum vyhotovenia snímky: </span>
              </p>
              <p id="date-of-acquisition">{this.state.acquisitionDate}</p>
            </div>

            {this.state.imgIndex === 0 && ( // dala som 100, aby sa to nezobrazilo, lebo tazko zakomentovat
              <>
                {/* <div className="layerControlBox"> */}
                <div>
                  {/* <strong className="layer-enhancement">
                      Maximálna hodnota pixelu:
                    </strong>
                    {this.state.maxValue !== undefined ? (
                      <output>
                        {parseFloat(this.state.maxValue).toFixed(0)}
                      </output>
                    ) : (
                      <output>{parseFloat(100).toFixed(0)}</output>
                    )}
                  </div>
                  <div className="maxValueButtons">
                    <button
                      className="ui button btnInLayerHeader container"
                      onClick={(e) => this.handleMaxValue(e, -20)}
                      title="- maximálna hodnota pixelu"
                    >
                      <i className="minus icon"></i>
                    </button>
                    <button
                      className="ui button btnInLayerHeader container"
                      onClick={(e) => this.handleMaxValue(e, +20)}
                      title="+ maximálna hodnota pixelu"
                    >
                      <i className="plus icon" />
                    </button>
                  </div> */}
                </div>
                <Accordion className="accordion">
                  <Accordion.Title
                    active={this.state.toggleActiveIndex === 0}
                    index={0}
                    onClick={this.onToggleFilter}
                    className="accordionTitle dpzAccordion"
                  >
                    <Icon name="dropdown" />
                    <strong className="title-h2">
                      Pokročilé vylepšenie RGB snímky
                    </strong>
                  </Accordion.Title>
                  <Accordion.Content
                    className="accordion-content layerControl-container"
                    active={this.state.toggleActiveIndex === 0}
                  >
                    <div className="layerControlBox-advanced">
                      <div className="leftColumn">
                        <div className="text-h1">Expozícia:</div>
                        {this.state.exposure !== undefined ? (
                          <output>
                            {parseFloat(this.state.exposure).toFixed(2)}
                          </output>
                        ) : (
                          <output>{parseFloat(0).toFixed(2)}</output>
                        )}
                      </div>
                      <div className="layerControlButtons">
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "exposure", -0.2)
                          }
                          title="- expozícia"
                        >
                          <i className="minus icon"></i>
                        </button>
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "exposure", +0.2)
                          }
                          title="+ expozícia"
                        >
                          <i className="plus icon"></i>
                        </button>
                      </div>
                    </div>

                    <div className="layerControlBox-advanced">
                      <div className="leftColumn">
                        <div className="text-h1">Kontrast:</div>
                        {this.state.contrast !== undefined ? (
                          <output>
                            {parseFloat(this.state.contrast).toFixed(2)}
                          </output>
                        ) : (
                          <output>{parseFloat(0).toFixed(2)}</output>
                        )}
                      </div>
                      <div className="layerControlButtons advanced">
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "contrast", -0.1)
                          }
                          title="- kontrast"
                        >
                          <i className="minus icon"></i>
                        </button>
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "contrast", +0.1)
                          }
                          title="+ kontrast"
                        >
                          <i className="plus icon"></i>
                        </button>
                      </div>
                    </div>

                    <div className="layerControlBox-advanced">
                      <div className="leftColumn">
                        <div className="text-h1">Sýtosť:</div>
                        {this.state.saturation !== undefined ? (
                          <output>
                            {parseFloat(this.state.saturation).toFixed(2)}
                          </output>
                        ) : (
                          <output>{parseFloat(0).toFixed(2)}</output>
                        )}
                      </div>
                      <span id="saturation-value"></span>
                      <div className="layerControlButtons advanced">
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "saturation", -0.2)
                          }
                          title="- sýtosť"
                        >
                          <i className="minus icon"></i>
                        </button>
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "saturation", +0.2)
                          }
                          title="+ sýtosť"
                        >
                          <i className="plus icon"></i>
                        </button>
                      </div>
                    </div>

                    <div className="layerControlBox-advanced">
                      <div className="leftColumn">
                        <div className="text-h1">Gamma:</div>
                        {this.state.gamma !== undefined ? (
                          <output>
                            {parseFloat(this.state.gamma).toFixed(2)}
                          </output>
                        ) : (
                          <output>{parseFloat(1).toFixed(2)}</output>
                        )}
                      </div>
                      <div className="layerControlButtons advanced">
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "gamma", -0.2)
                          }
                          title="- gamma"
                        >
                          <i className="minus icon"></i>
                        </button>
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "gamma", +0.2)
                          }
                          title="+ gamma"
                        >
                          <i className="plus icon"></i>
                        </button>
                      </div>
                    </div>

                    <div className="layerControlBox-advanced">
                      <div className="leftColumn">
                        <div className="text-h1">Jas:</div>
                        {this.state.brightness !== undefined ? (
                          <output>
                            {parseFloat(this.state.brightness).toFixed(2)}
                          </output>
                        ) : (
                          <output>{parseFloat(0).toFixed(2)}</output>
                        )}
                      </div>
                      <div className="layerControlButtons advanced">
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "brightness", -0.1)
                          }
                          title="- jas"
                        >
                          <i className="minus icon"></i>
                        </button>
                        <button
                          className="ui button btnInLayerHeader container"
                          onClick={(e) =>
                            this.handleStyleVariables(e, "brightness", +0.1)
                          }
                          title="+ jas"
                        >
                          <i className="plus icon"></i>
                        </button>
                      </div>
                    </div>
                    <div className="accordionFooter">
                      <button
                        className="ui button btnInLayerHeader container resetBtn"
                        onClick={() => this.resetRGB()}
                      >
                        {" "}
                        Reset
                        <i className="reset icon"></i>
                      </button>
                    </div>
                  </Accordion.Content>
                </Accordion>
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default RSLayerControl;
